const statMapping = {
  "s_passes_completed": "passComp",
  "s_passes_yards": "passYards",
  "s_passes_longest": "passLong",
  "s_passes_touchdowns": "passTd",
  "s_passes_intercepted": "passInt",
  "s_passes_percentage":"Comp%",
  "s_passes": "passAtt",
  "s_passes_sacked": "passSacks",
  "s_passes_yards_sacked": "passSackYards",
  "s_receptions": "rcvNum",
  "s_receptions_yards": "rcvYards",
  "s_receptions_longest": "rcvLong",
  "s_receptions_touchdown": "rcvTd",
  "s_rushing_attempts": "rushAtt",
  "s_rushing_yards_net": "rushYards",
  "s_rushing_yards_gain": "rushGain",
  "s_rushing_longest": "rushLong",
  "s_rushing_touchdowns": "rushTd",
  "s_rushing_yards_loss": "rushLoss",
  "s_fumbles_lost": "fumbLost",
  "s_fumbles_total": "fumbTotal",
  "s_penalty": "penTotal",
  "s_penalty_yards": "penYards",
  "s_kick_on_side_attempts": "ona",
  "s_kicks_on_side": "onm",
  "s_tackles_assisted": "dTackA",
  "s_tackles_solo": "dTackUa",
  "s_tackles_total": "dTackTot",
  "s_pass_interceptions": "irNo",
  "s_interceptions_return_yards": "irYards",
  "s_pass_break_ups": "dBrup",
  "s_sacks_unassisted": "dSackUa",
  "s_sacks_assisted": "dSackA",
  "s_sacks_total": "dSacks",
  "s_sacks_yards": "dSackYards",
  "s_pass_quarterback_hurries": "dQbh",
  "s_fumbles_forced": "dFf",
  "s_pass_efficiency":"Pass Eff",
  "s_fumbles_recovered": "dFr",
  "s_fumble_return_yards": "dFryds",
  "s_fumble_return_touchdowns": "dFrTds",
  "s_passes_average_yards_per_completion":"AVG Yds/Comp",
  "s_kicks_blocked_by": "dblkd",
  "s_tackles_for_loss_assisted": "dTfla",
  "s_tackles_for_loss_solo": "dTflua",
  "s_tackles_for_loss_total": "dTflTot",
  "s_tackles_yards": "dTflyds",
  "s_interceptions_touchdowns": "irTd",
  "s_interceptions_return_longest": "irLong",
  "s_field_goals_made": "fg",
  "s_field_goals_attempted": "fgAtt",
  "s_field_goal_made_longest": "fgLong",
  "s_field_goals_blocked": "fgBlocked",
  "s_pat_kicks_attempted": "kickatt",
  "s_pat_kicks_made": "patKick",
  "s_pat_pass_attempts": "passatt",
  "s_pat_passes": "passmade",
  "s_pat_rush_attempts": "rushatt",
  "s_pat_rushes": "rushmade",
  "s_kickoffs_total": "koNum",
  "s_kickoffs_gross_yards": "koYards",
  "s_kickoffs_touchbacks": "koTb",
  "s_kickoffs_out_of_bound": "koOb",
  "s_kick_returns_total": "krNo",
  "s_kick_returns_yards": "krYards",
  "s_kick_returns_touchdowns": "krTd",
  "s_kick_returns_longest": "krLong",
  "s_punts": "puntNum",
  "s_punts_yards": "puntYards",
  "s_punts_50plus": "puntPlus50",
  "s_punts_inside20": "puntInside20",
  "s_punts_longest": "puntLong",
  "s_punts_touchbacks": "puntTb",
  "s_punts_fair_catches": "puntFc",
  "s_punts_blocked": "puntBlocked",
  "s_punt_returns": "prNo",
  "s_punt_returns_yards": "prYards",
  "s_punt_returns_touchdown": "prTd",
  "s_punt_returns_longest": "prLong",
  "s_touchdowns": "td",
  "s_yards_offensive_total": "TotOffYds",
  "s_yards_all_purpose_total": "AllPurYds",
  "s_pat_percentage":"PAT Pass Comp%",
  "s_passes_yards_per_attempt":"Pass Att",
  "s_passes_yards_per_catch":"AVG Yds/Comp",
  "s_punts_average":"Punt AVG",
"s_pat_attempts":"PAT att",
"s_pat_made":"PAT Kick Made",
"s_pat_two_points_attempt":"PAT 2 pt att",
"s_pat_two_points_made":"PAT 2pt made",
"s_plays_total":"Tot Plays",
"s_rushing_net_yards_average":"Rush AVG",
"s_yards_per_play_average":"Yds/Play AVG",
"s_passes_interception_percentage":"Pass INT%",
"s_passes_touchdown_percentage":"TD Pass %"
}

export default statMapping;